<template>
  <v-card>
    <v-card-title class=" p-4 pb-3">
      <p 
        v-if="module.block"
        class="font-weight-black w-100 mb-0"
      >
        {{ module.block.trail.acronym }} | {{ module.block.name }} 
        <span v-if="module.block.suffix"> {{ module.block.suffix }} </span>
      </p>
      <hr 
        v-show="module.block"
        class="w-100 my-1"
      >
      <p class="w-100">
        <span class="font-weight-black">{{ module.name }}</span>
        <span v-if="module.description">{{ module.description }}</span>
      </p>
    </v-card-title>
    <div
      class="position-relative p-4 m-4"
      style="min-height: 300px"
    >
      <VideoComponent :content="module.video" />
    </div>
    <v-card-actions>
      <slot />
    </v-card-actions>
  </v-card>
</template>
<script>

import VideoComponent from '@/student/components/module/content/VideoComponent.vue'

export default {
  components: {
    VideoComponent
  },
    props: {
      module: {
        type: Object,
        required: true,
      },
  },
}
</script>
<style scoped>
  p{
    word-break: break-word;
  }
</style>
